export const getHtmlTemplateForCalculator = (calculatorReportValue = {}) => {
  const [mainResult, ...rest] = Object.values(calculatorReportValue)
  let returnableTitle = ''
  if (mainResult && mainResult.title) {
    returnableTitle = `<h3>
    ${mainResult.title}: ${mainResult.unit || 'SAR'} ${Number(
      mainResult.value,
    ).toFixed(2)}
  </h3>`
  }

  const returnAbleTables = rest
    .map((reportObject) => {
      if (!reportObject.length) return null
      return `<div style="width: 100%; display: block; margin: 12px 0;">
      ${reportObject
        .map(
          (item) =>
            `<p>
                <b>${item.title || item.label}: </b>
              <span>
                ${Number(item.value).toFixed(2)} ${item.unit}
              </span>
            </p>`,
        )
        .join('')}
        </tbdody>
    </div>`
    })
    .join('')

  return `<div style="display: block; width: 100%">
          ${returnableTitle}
          ${returnAbleTables}
  </div>
  `
}
